/*
 * jQuery for tabs
 */
(function ($) {

    // On DOM ready
    $(function () {
        videoOverlay();

    });


    /*
     * Video overlay
     */

    function videoOverlay() {
        $(document).on('click', '.img-slider .col-three', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('.img-slider .col-three').removeClass('active');
            $(this).addClass('active');
            $(this).find(".img-outer").clone().appendTo(".img-overlay .img-box .img-container");
            $('body').addClass('overlay-active');
            $(".img-overlay").addClass("img-active");
        });
        closeVideoOverlay();
    }

    function closeVideoOverlay() {
        $('.closeVideo').on('click', function () {
            $('body').removeClass('overlay-active');
            $('.img-slider .col-three').removeClass('active');
            $('.img-overlay').removeClass("img-active");
            $(".img-overlay .img-box .img-container .img-outer").remove();
        });

        // Close video overlay on outside click
        $('.img-overlay .v-middle-inner').on('click', function () {
            $('body').removeClass('overlay-active');
            $('.img-slider .col-three').removeClass('active');
            $('.img-overlay').removeClass("img-active");
            $(".img-overlay .img-box .img-container .img-outer").remove();
        });
    }

    function videoOverlay() {
        $(document).on("click", '.article-detail .article-slider .col-wrap', function (e) {
            e.preventDefault();
            var img = $(this).find(".img-wrap").clone();

            $(".img-video-overlay").find(".img-video-container").html(img);
            $(".img-video-overlay").addClass("overlay-active");

        });
        closeVideoOverlay();
    }

})(jQuery);
